var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32402 16.3941C12.6888 16.3941 16.2271 12.8558 16.2271 8.49102C16.2271 4.12624 12.6888 0.587891 8.32402 0.587891C3.95925 0.587891 0.420898 4.12624 0.420898 8.49102C0.420898 12.8558 3.95925 16.3941 8.32402 16.3941Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17893 11.9157C7.17717 11.9157 7.17541 11.9157 7.17383 11.9157C6.94552 11.9141 6.72897 11.814 6.58004 11.6412L4.21297 8.89214C3.92811 8.56144 3.96534 8.06231 4.29622 7.77745C4.62709 7.49276 5.12605 7.52999 5.41091 7.8607L7.18683 9.92324L11.2448 5.33328C11.5337 5.00626 12.0332 4.97553 12.3604 5.26461C12.6874 5.55369 12.7181 6.05316 12.4291 6.38018L7.77131 11.6489C7.62097 11.8186 7.40531 11.9157 7.17893 11.9157Z",
    fill: "#18A09F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSelectedIcon);
export default __webpack_public_path__ + "static/media/ProductSelectedIcon.b41fc8924583ecff9b519fe073ef525a.svg";
export { ForwardRef as ReactComponent };